import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

/**
 * Shape of the 'Exemple' Redux dlice state.
 */
export interface ExempleState {
    data1?: string;
    data2?: number;
}

const initialState: ExempleState = {
    data2: 1337,
};

const exempleSlice = createSlice({
    name: 'exemple',
    initialState,
    reducers: {
        /**
         * Replaces the entire 'Exemple' state with the dispatched payload.
         * @param _ - Previous state (discarded.
         * @param action - Action carrying the new 'ExempleState' object.
         */
        setExemple: (_, action: PayloadAction<ExempleState>) => {
            return action.payload;
        },
    },
});

/**
 * React hook to read the 'Exemple' slice state from the Redux store.
 *
 * @returns the current 'ExempleState' record.
 *
 * @exemple
 * ```ts
 * const exemple = useExemple();
 * const label = exemple?.data1;
 * ```
 */
export function useExemple() {
    return useSelector((state: { exemple: ExempleState }) => state.exemple);
}

/**
 * Action creator to set (or replace) the 'Exemple' state in the Redux store.
 */

export const { setExemple } = exempleSlice.actions;

export default exempleSlice.reducer;
